import styled from "styled-components";
import { Paper, TextField, Button, TextareaAutosize } from "@mui/material";

export const TurnInContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
`;

export const StepContainer = styled(Paper)`
  padding: 40px;
  width: 100%;
  max-width: 600px;
`;

export const StyledTextField = styled(TextField)`
  margin: 10px 0 !important;
`;

export const SubQuestionWrapper = styled.div`
  margin: 10px 25px;
  flex-direction: row;
  flex: 1;
`;

export const InspectionItemContainer = styled.div`
  background-color: #f6f6f6;
  margin: 15px 0;
  padding: 10px 35px 10px 15px;
  border: 1px #CCC solid;
`;

export const StyledFormLabel = styled.span`
  margin: 5px 0;
  font-weight: bold;
  color: #3b3b3b;
`;

export const StyledTextArea = styled(TextareaAutosize)`
  width: 100%;
`

export const ChargeList = styled.div`
`;

export const ChargeItem = styled.div`
  background-color: rgba(0, 0, 0, 0.1);
  padding: 10px 0;
  margin: 5px 0;
`;

export const ChargeTitle = styled.h4`
  margin: 5px 0;
  color: rgba(0, 0, 0, 0.7)
`;

export const ChargeItemAmount = styled.p`
  margin: 0 0 5px 0;
`
